import { Route, Switch } from 'react-router-dom';
import { FC, useContext } from 'react';
import Menu from './components/Menu';
import Events from './pages/Events/Events';
import Libraries from './pages/Libraries';
import Configs from './pages/Configs/Configs';
import UnsupportedSources from './pages/MissingSources';
import HealthMonitor from './pages/HealthMonitor';
import Requests from './pages/Requests';
import FileManager from './pages/FileManager';
import Statistics from './pages/Statistics';
import Heartbeats from './pages/Heartbeats';
import { AuthContext } from './components/Authentication';


const App: FC<{ }> = () => {
    const { user } = useContext(AuthContext);
    if (!user) {
        return <div>Not authenticated.</div>;
    }

    const routing = {
        '/': Events,
        '/events': Events,
        '/libraries': Libraries,
        '/configs': Configs,
        '/health_monitor': HealthMonitor,
        '/statistics': Statistics,
        '/unsupported_sources': UnsupportedSources,
        '/requests': Requests,
        '/heartbeats': Heartbeats,
        '/file_manager': FileManager,
    };

    return (
        <>
            <Menu items={Object.keys(routing).slice(1)} />

            <Switch>
                {Object.entries(routing).map(([path, component]) => (
                    <Route exact {...{path, component, key: path}} />
                ))}
            </Switch>
        </>
    );
};

export default App;
